import { OrderMarketTypeEnum } from './../../enum/orders/market-type.enum';
import { OrderStatus } from './../../enum/orders/order-status.enum';
import { OrderOriginTypeEnum } from '../../enum/orders/origin-type.enum';
import { Order } from './order.model';

export class Strategy {
    
    creationDate: string;
    executionDate: string;
    isDayTrade: boolean;
    legs: Array<Order>;
    orderMaketTypeDescription:string
    orderMarketType: OrderMarketTypeEnum
    originDescription: string;
    originType: OrderOriginTypeEnum;
    researchID: number;
    status: OrderStatus
    statusDescription: string;
    strategyID: string;
    symbol: string;
    updatedAt: string;

    constructor(){
        this.legs = [];
    }
}